import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgFile = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.686 3.676a.52.52 0 0 1 .382-.176h5.84v6.365c0 .415.337.75.75.75H18.5v9.212a.73.73 0 0 1-.186.496.52.52 0 0 1-.382.177H6.068a.52.52 0 0 1-.382-.177.73.73 0 0 1-.186-.496V4.173c0-.196.073-.374.186-.497M19.984 9.71a.74.74 0 0 0-.184-.353L13.21 2.24a.75.75 0 0 0-.55-.24H6.068c-.569 0-1.1.244-1.483.657C4.205 3.068 4 3.614 4 4.173v15.654c0 .558.205 1.105.586 1.516.383.413.914.657 1.482.657h11.864c.568 0 1.1-.244 1.482-.657.381-.411.586-.957.586-1.516V9.865a.8.8 0 0 0-.017-.156m-6.575-5.046 4.124 4.452h-4.124z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgFile;
